import { defineStore } from 'pinia';
import { computed, reactive, ref } from 'vue';

import type { ContentCounts } from '~/components/MyLibraryV2/Constants';
import {
  QUIZ_STATUS,
  contentStatusCountParamsMap,
} from '~/components/MyLibraryV2/Constants';

const defaultContentCounts: ContentCounts = Object.entries(contentStatusCountParamsMap)
  .reduce((acc, [, countKey]) => ({ ...acc, [countKey]: 0 }), {}) as ContentCounts;

// will need to rename as ll manager or something,
const useContentCountStore = defineStore('contentCount', () => {
  const countsInitialised = ref(false);

  const loading = ref(false);

  const contentCounts: ContentCounts = reactive(defaultContentCounts);

  const publishedCount = computed(() => contentCounts[contentStatusCountParamsMap[QUIZ_STATUS.PUBLISHED]]);

  const draftCount = computed(() => contentCounts[contentStatusCountParamsMap[QUIZ_STATUS.DRAFT]]);

  const archivedCount = computed(() => contentCounts[contentStatusCountParamsMap[QUIZ_STATUS.ARCHIVED]]);

  const lifetimeAccessCount = computed(() => contentCounts[contentStatusCountParamsMap[QUIZ_STATUS.LIFETIME_ACCESS]]);

  function startLoading() {
    loading.value = true;
  }

  function endLoading() {
    loading.value = false;
  }

  function markStoreAsInitialised() {
    countsInitialised.value = true;
  }

  function setContentCounts(counts: object) {
    markStoreAsInitialised();
    Object.assign(contentCounts, counts);
  }

  function incrementContentStatusCountByKey(key: keyof ContentCounts, delta: number = 1) {
    contentCounts[key] += delta;
  }

  function decrementContentStatusCountByKey(key: keyof ContentCounts, delta: number = 1) {
    contentCounts[key] = Math.max(contentCounts[key] - delta, 0);
  }

  return {
    contentCounts,
    loading,
    // all the counts
    publishedCount,
    draftCount,
    archivedCount,
    lifetimeAccessCount,

    // initialised once
    countsInitialised,

    // will be used to bootstrap store
    setContentCounts,
    startLoading,
    endLoading,
    markStoreAsInitialised,

    // will be used to refresh store counts
    decrementContentStatusCountByKey,
    incrementContentStatusCountByKey,
  };
});

export default useContentCountStore;
